'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

const Translator = require('./../../../../core/translator');

const FormBuilder = require('./../../builder');

const tplCopyBtn = require('./template/copy_text_btn.hbs');

let ElementClass = require('./../../elementClass');

FormBuilder.register('text', function(config) {
  let self = {};

  self = new ElementClass(config);

  self.render = function($wrap) {
    let $element = jQuery('<input/>');
    let $label;

    $element.attr('type', 'text');
    $element.attr('name', self.name);

    if (self.disabled) {
      $element.attr('disabled', self.disabled);
      $element.addClass('disabled');
    }

    if (config.readonly) {
      $element.attr('readonly', 'readonly');
    }

    if (config.autocomplete === false) {
      $element.attr('autocomplete', 'off');
    }

    if (undefined !== self.placeholder) {
      $element.attr('placeholder', self.placeholder);
    }

    if (config.value !== undefined && config.value !== null) {
      $element.val(Translator.translate(config.value));
    }

    if (self.elementClass) {
      $element.addClass(self.elementClass);
    }

    if (typeof config.onChange === 'function') {
      $element.on('change', config.onChange);
    }

    if (self.label || self.question) {
      $label = jQuery('<label/>');

      if (self.labelClass) {
        $label.addClass(self.labelClass);
      }

      $label.append(self.label);

      if (self.question) {
        $label.append(jQuery(`<a class="cloud-question" target="_blank" rel="noopener" href="${self.question}">?</a>`));
      }

      $wrap.append($label);
    }

    if (config.copyText) {
      let $groupAppend = jQuery('<div class="input-group-append"></div>');

      $groupAppend.append($element);
      $groupAppend.append(jQuery(tplCopyBtn()));
      $wrap.append($groupAppend);

      $wrap.find('.input-group-append.btn-copy-wrapper').on('click', function() {
        $element.select();
        document.execCommand('copy');
        jQuery(this).attr('data-original-title', Translator.translate('copied_id'));
      });
    } else {
      $wrap.append($element);
    }

    if (config.description) {
      $wrap.append(jQuery('<blockquote class="cloud-description">' + Translator.translate(config.description) + '</blockquote>'));
    }
  };

  self.getData = function() {
    let value = self.$.find('input:first').val();

    if (config.format === 'URL' && !_.isEmpty(value)) {
      if (!value.match(/^[a-zA-Z]+:\/\//) && value.substr(0, 1) !== '/') {
        (!value.charAt(0) === '#') ? value = 'https://' + value : value;
      }
    }

    return value;
  };

  return self;
});
